export default __webpack_public_path__ + "static/media/detail_mobile_5_4.79361a67.png";